export function initial() {
    return {
        isLoading: false,
        isLoaded: false,
        hasError: false,
        error: undefined,
        data: undefined
    }
}

export function load(state) {
    return {
        ...state,
        isLoading: true,
        isLoaded: false,
        hasError: false,
        error: undefined,
        /*data: undefined*/
    };
}

export function save(state, data) {
    return {
        ...state,
        isLoading: false,
        isLoaded: true,
        hasError: false,
        error: undefined,
        data: data
    };
}

export function error(state, error) {
    return {
        ...state,
        isLoading: false,
        isLoaded: false,
        hasError: true,
        error: error.message
    };
}


// WEBPACK FOOTER //
// ./src/misc/actions.js